"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateContactPersonReducer = exports.createContactPersonReducer = exports.searchContactPersonReducer = exports.fetchContactPersonReducer = exports.updateContactPersonSlice = exports.createContactPersonSlice = exports.searchContactPersonSlice = exports.fetchContactPersonSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const contactPersonAction_1 = require("./contactPersonAction");
const fetchIntitialState = {
    loading: false,
    error: null,
    data: []
};
const searchIntitialState = {
    loading: false,
    error: null,
    data: []
};
const createIntitialState = {
    loading: false,
    error: null,
    data: []
};
const updateIntitialState = {
    loading: false,
    error: null,
    data: []
};
exports.fetchContactPersonSlice = (0, toolkit_1.createSlice)({
    name: 'contactPerson/fetch',
    initialState: fetchIntitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(contactPersonAction_1.fetch.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(contactPersonAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(contactPersonAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.searchContactPersonSlice = (0, toolkit_1.createSlice)({
    name: 'contactPerson/search',
    initialState: searchIntitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(contactPersonAction_1.search.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(contactPersonAction_1.search.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(contactPersonAction_1.search.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.createContactPersonSlice = (0, toolkit_1.createSlice)({
    name: 'contactPerson/create',
    initialState: createIntitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(contactPersonAction_1.create.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(contactPersonAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(contactPersonAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.updateContactPersonSlice = (0, toolkit_1.createSlice)({
    name: 'contactPerson/update',
    initialState: updateIntitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(contactPersonAction_1.update.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(contactPersonAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(contactPersonAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchContactPersonReducer = exports.fetchContactPersonSlice.reducer;
exports.searchContactPersonReducer = exports.searchContactPersonSlice.reducer;
exports.createContactPersonReducer = exports.createContactPersonSlice.reducer;
exports.updateContactPersonReducer = exports.updateContactPersonSlice.reducer;
